import { SelectTypeaheadComponent } from './select-typeahead/select-typeahead.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { TopMenuComponent } from './top-menu/top-menu.component';
import { JobComponent } from './job/job.component';
import { AddStopComponent } from './popups/add-stop/add-stop.component';
import { AnSelectComponent } from './an-select/an-select.component';
import { LoaderComponent } from './loader/loader.component';
import { MapComponent } from './map/map.component';
import { AddressPipe } from './directives/address/address.pipe';
import { DateDiffPipe } from './directives/date-diff/date-diff.pipe';
import { AddEventComponent } from './popups/add-event/add-event.component';
import { NoJobsComponent } from './no-jobs/no-jobs.component';
import { JobShipperComponent } from './job-shipper/job-shipper.component';
import { AddNoteComponent } from './popups/add-note/add-note.component';
import { AddToMarketplaceComponent } from './popups/add-to-marketplace/add-to-marketplace.component';
import { CreateJobComponent } from './create-job/create-job.component';
import { ProfilePhotoComponent } from './profile-photo/profile-photo.component';
import { ProfileMenuComponent } from './profile-menu/profile-menu.component';
import { JobDocumentsComponent } from './job-documents/job-documents.component';
import { ConfirmationPopupComponent } from './popups/confirmation-popup/confirmation-popup.component';
import { OffersComponent } from './offers/offers.component';
import { SharedTemplatesComponent } from './shared-templates/shared-templates.component';
import { ShippingLocationsComponent } from './shared-templates/shipping-locations/shipping-locations.component';
import { ClientsTabComponent } from './shared-templates/clients-tab/clients-tab.component';
import { CargoTabComponent } from './shared-templates/cargo-tab/cargo-tab.component';
import { AddNewComponent } from './shared-templates/add-new/add-new.component';
import { ToastersComponent } from './toasters/toasters.component';
import { DragAndDropDirective } from './directives/dragAndDrop/dragAndDrop.directive';
import { ExtendOfferComponent } from './popups/extend-offer/extend-offer.component';
import { PricingMatrixComponent } from './pricing-matrix/pricing-matrix.component';
import { FeatureFlagDirective } from './directives/feature-flag/feature-flag.directive';
import { PhoneComponent } from './phone/phone.component';
import { DotsComponent } from './dots/dots.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { DateAgoPipe } from './directives/date-ago/date-ago.pipe';
import { AdditionalInfoComponent } from './additional-info/additional-info.component';
import { BackToAdminComponent } from './back-to-admin/back-to-admin.component';
import { DirectContractJobComponent } from './popups/direct-contract-job/direct-contract-job.component';
import { UploadFileComponent } from './upload-file/upload-file.component';
import { VerificationStatusComponent } from './verification-status/verification-status.component';
import { DebounceDirective } from './directives/debounce/debounce.directive';
import { DropdownComponent } from './filter-dropdown/dropdown.component';
import { JobButtonsComponent } from './job-buttons/job-buttons.component';
import { ShareContractJobComponent } from './popups/share-contract-job/share-contract-job.component';
import { UsersEditingComponent } from './users-editing/users-editing.component';
import { JobShipperListViewComponent } from './job-shipper-list-view/job-shipper-list-view.component';
import { SubconAddToMarketplaceComponent } from './popups/subcon-add-to-marketplace/subcon-add-to-marketplace.component';
import { LogoComponent } from './logo/logo.component';
import { NoNegativeNumberValuePipe } from './directives/no-negative-number-value/no-negative-number-value.pipe';
import { GraphModule } from './graph/graph.module';
import { CompanyDocumentsComponent } from './company-documents/company-documents.component';
import { EcologiPopupComponent } from './popups/ecologi-popup/ecologi-popup.component';
import { AddWarningComponent } from './popups/add-warning/add-warning.component';
import { ExtraChargeComponent } from './popups/extra-charge/extra-charge.component';
import { LoadsFilterComponent } from './popups/loads-filter/loads-filter.component';
import { SpecialInstructionsComponent } from './popups/special-instructions/special-instructions.component';
import { UserFormPopupComponent } from './popups/user-form-popup/user-form-popup.component';
import { EditLoadReasonComponent } from './popups/edit-load-reason/edit-load-reason.component';
import { SimpleModalComponent } from './popups/confirmation-modal/simple-modal.component';
import { MailingPreferencesComponent } from './popups/mailing-preferences/mailing-preferences.component';
import { PlaceOfferComponent } from './popups/place-offer/place-offer.component';
import { ShareLoadComponent } from './share-load/share-load.component';
import { CancelJobReasonComponent } from './popups/cancel-job-reason/cancel-job-reason.component';
import { SharedLinkComponent } from './shared-link/shared-link.component';
import { RadioSelectWithNoteModalComponent } from './popups/radio-select-with-note-modal/radio-select-with-note-modal.component';
import { CancelLoadAdminModalComponent } from './popups/cancel-load-admin-modal/cancel-load-admin-modal.component';
import { AddExtraChargeComponent } from './popups/add-extra-charge/add-extra-charge.component';
import { DateWithTzPipe } from './directives/date-with-tz/date-with-tz.pipe';
import { PaginationScrollWithButtonComponent } from './pagination-scroll-with-button/pagination-scroll-with-button.component';
import { MultiSelectDropdownComponent } from './multiselect-dropdown/multiselect-dropdown.component';
import { VerifyDocumentsComponent } from './popups/verify-documents/verify-documents.component';
import { StopActualTimesPopupComponent } from './popups/stop-actual-times-popup/stop-actual-times-popup.component';
import { HaulierDemoOverlayComponent } from './haulier-demo/haulier-demo.component';
import { PieChartComponent } from './charts/pie-chart/pie-chart.component';
import { TimelineChartComponent } from './charts/timeline-chart/timeline-chart.component';
import { BarChartComponent } from './charts/bar-chart/bar-chart.component';
import { NgChartsModule } from 'ng2-charts';
import { TypeaheadMultiselectComponent } from './typeahead-multiselect/typeahead-multiselect.component';
import { HaulierNotActiveComponent } from './haulier-not-active/haulier-not-active.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { PreventNegativeAndDecimalNumbersDirective } from './directives/prevent-decimal-and-negative-value/prevent-decimal-and-negative-value.directive';
import { TenantStatusToggleComponent } from './tenant-status-toggle/tenant-status-toggle.component';
import { CreateShipperPopupComponent } from './popups/create-shipper-popup/create-shipper-popup.component';
import { AddVehiclesAndTrailersPopup } from './popups/add-vehicles-and-trailers/add-vehicles-trailers-popup.component';
import { TruckTypePipe } from './directives/truck-type/truck-type.pipe';
import { TrailerTypePipe } from './directives/trailer-type/trailer-type.pipe';
import { EngineFuelTypePipe } from './directives/engine-fuel-type/engine-fuel-type.pipe';
import { SpecialEquipmentPipe } from './directives/special-equipment/special-equipment.pipe';
import { NotesComponent } from './notes/notes.component';
import { AssignDriverComponent } from './assign-driver/assign-driver.component';
import { InfoBubbleComponent } from './popups/info-bubble/info-bubble.component';
import { TypeaheadComponent } from './typeahead/typeahead.component';
import { FuelTypePipePipe } from './directives/fuel-type-pipe/fuel-type-pipe.pipe';
import { SKUListComponent } from './popups/sku-list/sku-list.component';
import { HaulierRatingComponent } from './haulier-rating/haulier-rating.component';
import { ChatComponent } from './chat/chat.component';
import { LoadsMoreFiltersComponent } from './popups/loads-more-filters/loads-more-filters.component';
import { ContractJobsListComponent } from './contract-jobs-list/contract-jobs-list.component';
import { ExtraChargeNoteComponent } from './extra-charge-note/extra-charge-note.component';
import { RenewContractComponent } from './popups/renew-contract/renew-contract.component';
import { PublishLoadComponent } from './popups/publish-load/publish-load.component';
import { BookLoadComponent } from './popups/publish-load/book-load/book-load.component';
import { ShareLoadsComponent } from './popups/publish-load/share-loads/share-loads.component';
import { AddInnerLocationPopupComponent } from './shared-templates/add-inner-location/add-inner-location.component';
import { ShipFromSectionComponent } from './shared-templates/add-inner-location/ship-from-section/ship-from-section.component';
import { WorkingHoursSectionComponent } from './shared-templates/add-inner-location/working-hours-section/working-hours-section.component';
import { GatesSectionComponent } from './shared-templates/add-inner-location/gates-section/gates-section.component';
import { SkuRejectionReasonsPipe } from './directives/sku-rejection-reasons-pipe/sku-rejection-reasons-pipe';
import { AddEditSkuListComponent } from './popups/add-edit-sku-list/add-edit-sku-list.component';
import { CreateLoadForShipperOrClientPopupComponent } from './create-load-shipper-or-client-popup/create-load-shipper-or-client.component';
import { RemoveZeroValueOnInputFocus } from './directives/remove-zero-value-on-input-focus/remove-zero-value-on-input-focus';
import { DeliveredOnTimeStatusComponent } from './popups/delivered-on-time-status/delivered-on-time-status.component';
import { ContractJobFiltersComponent } from './contract-jobs-list/contract-job-filters/contract-job-filters.component';
import { ExtraChargeReasonPipePipe } from './directives/extra-charge-reason-pipe.pipe';
import { FormatDistanceUnitPipe } from './directives/format-distance-unit/format-distance-unit';
import { BucksPerDistancePipe } from './directives/bucks-per-distance-pipe/bucks-per-distance-pipe';
import { MonthPickerComponent } from './month-picker/month-picker.component';
import { WeekPickerComponent } from './week-picker/week-picker.component';
import { DateRangePipePipe } from './directives/date-range-pipe/date-range-pipe.pipe';
import { ToggleSwitchComponent } from './toggle-switch/toggle-switch.component';
import { RequestChangesComponent } from './popups/request-changes/request-changes.component';
import { DayPickerWithWeekdayComponent } from './day-picker-with-weekday/day-picker-with-weekday.component';
import { ClientSearchComponent } from './clients-search/clients-search.component';
import { ShipperSearchComponent } from './shipper-search/shipper-search.component';
import { LocationSearchComponent } from './location-search/location-search.component';
import { AddVehicleToYardComponent } from './popups/add-vehicle-to-yard/add-vehicle-to-yard.component';
import { VehicleOnYardStatusPipe } from './directives/vehicle-on-yard-pipe/vehicle-on-yard-status.pipe';
import { LoadingStartedPopupComponent } from './popups/loading-started-popup/loading-started-popup.component';
import { HaulierSearchComponent } from './haulier-search/haulier-search.component';
import { PlatformNameReplacePipe } from './directives/platform-name-replace/platform-name-replace.pipe';
import { ActivateJobComponent } from './popups/activate-job/activate-job.component';
import { ContractJobContextMenuComponent } from './context-menu/contract-job-context-menu/contract-job-context-menu.component';
import { ContractJobsMasterListComponent } from './contract-job-master-list/contract-jobs-master-list.component';
import { ContractJobMasterComponent } from './contract-job-master/contract-job-master.component';
import { ContractMasterContextMenuComponent } from './context-menu/contract-job-master-context-menu/contract-job-master-context-menu.component';
import { AddNewOrderComponent } from './popups/add-new-order/add-new-order.component';
import { StopComponent } from './stop/stop.component';
import { StopDocumentsUploadComponent } from '../contract-job-master/components/stop-documents-upload/stop-documents-upload.component';
import { SkuOveragesReasonsPipe } from './directives/sku-overages-reasons-pipe/sku-overages-reasons-pipe';
import { FixedTwoPipe } from './directives/fixed-two/fixed-two.pipe';
import { ClickOutsideDirective } from './directives/click-outside/click-outside.directive';
import { BidHistoryComponent } from './popups/bid-history/bid-history.component';
import { CheckHaulierPermissionPipe } from './directives/check-haulier-permission.pipe';
import { NoPermissionScreenComponent } from './no-permission/no-permission-screen.component';
import { CheckShipperPermissionPipe } from './directives/check-shipper-permission.pipe';

@NgModule({
  declarations: [
    TopMenuComponent,
    JobComponent,
    AddStopComponent,
    AnSelectComponent,
    LoaderComponent,
    MapComponent,
    AddressPipe,
    DateDiffPipe,
    AddEventComponent,
    NoJobsComponent,
    JobShipperComponent,
    SelectTypeaheadComponent,
    AddNoteComponent,
    AddToMarketplaceComponent,
    CreateJobComponent,
    ProfilePhotoComponent,
    ProfileMenuComponent,
    JobDocumentsComponent,
    ConfirmationPopupComponent,
    OffersComponent,
    SharedTemplatesComponent,
    ShippingLocationsComponent,
    ClientsTabComponent,
    CargoTabComponent,
    AddNewComponent,
    ToastersComponent,
    DragAndDropDirective,
    ExtendOfferComponent,
    PricingMatrixComponent,
    FeatureFlagDirective,
    PhoneComponent,
    DotsComponent,
    NotificationsComponent,
    DateAgoPipe,
    AdditionalInfoComponent,
    BackToAdminComponent,
    DirectContractJobComponent,
    UploadFileComponent,
    VerificationStatusComponent,
    DebounceDirective,
    DropdownComponent,
    JobButtonsComponent,
    ShareContractJobComponent,
    UsersEditingComponent,
    JobShipperListViewComponent,
    SubconAddToMarketplaceComponent,
    LogoComponent,
    NoNegativeNumberValuePipe,
    CompanyDocumentsComponent,
    EcologiPopupComponent,
    AddWarningComponent,
    ExtraChargeComponent,
    LoadsFilterComponent,
    SpecialInstructionsComponent,
    UserFormPopupComponent,
    EditLoadReasonComponent,
    SimpleModalComponent,
    MailingPreferencesComponent,
    PlaceOfferComponent,
    ShareLoadComponent,
    CancelJobReasonComponent,
    SharedLinkComponent,
    RadioSelectWithNoteModalComponent,
    AddExtraChargeComponent,
    CancelLoadAdminModalComponent,
    DateWithTzPipe,
    PaginationScrollWithButtonComponent,
    MultiSelectDropdownComponent,
    VerifyDocumentsComponent,
    StopActualTimesPopupComponent,
    HaulierDemoOverlayComponent,
    PieChartComponent,
    TimelineChartComponent,
    BarChartComponent,
    TypeaheadMultiselectComponent,
    HaulierNotActiveComponent,
    ChangePasswordComponent,
    PreventNegativeAndDecimalNumbersDirective,
    TenantStatusToggleComponent,
    CreateShipperPopupComponent,
    AddVehiclesAndTrailersPopup,
    TruckTypePipe,
    TrailerTypePipe,
    EngineFuelTypePipe,
    SpecialEquipmentPipe,
    NotesComponent,
    AssignDriverComponent,
    InfoBubbleComponent,
    TypeaheadComponent,
    FuelTypePipePipe,
    SKUListComponent,
    ChatComponent,
    HaulierRatingComponent,
    LoadsMoreFiltersComponent,
    ContractJobsListComponent,
    ContractJobContextMenuComponent,
    ContractMasterContextMenuComponent,
    ExtraChargeNoteComponent,
    RenewContractComponent,
    PublishLoadComponent,
    BookLoadComponent,
    ShareLoadsComponent,
    AddInnerLocationPopupComponent,
    ShipFromSectionComponent,
    WorkingHoursSectionComponent,
    GatesSectionComponent,
    SkuRejectionReasonsPipe,
    SkuOveragesReasonsPipe,
    AddEditSkuListComponent,
    CreateLoadForShipperOrClientPopupComponent,
    RemoveZeroValueOnInputFocus,
    DeliveredOnTimeStatusComponent,
    ContractJobFiltersComponent,
    ExtraChargeReasonPipePipe,
    FormatDistanceUnitPipe,
    BucksPerDistancePipe,
    MonthPickerComponent,
    WeekPickerComponent,
    DateRangePipePipe,
    ToggleSwitchComponent,
    RequestChangesComponent,
    DayPickerWithWeekdayComponent,
    ClientSearchComponent,
    ShipperSearchComponent,
    LocationSearchComponent,
    AddVehicleToYardComponent,
    VehicleOnYardStatusPipe,
    LoadingStartedPopupComponent,
    HaulierSearchComponent,
    PlatformNameReplacePipe,
    ActivateJobComponent,
    ContractJobsMasterListComponent,
    ContractJobMasterComponent,
    AddNewOrderComponent,
    StopComponent,
    StopDocumentsUploadComponent,
    ClickOutsideDirective,
    BidHistoryComponent,
  ],
  imports: [
    CommonModule,
    ScrollingModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    NgbModule,
    GraphModule,
    NgChartsModule,
    NgOptimizedImage,
    FixedTwoPipe,
    CheckHaulierPermissionPipe,
    NoPermissionScreenComponent,
    CheckShipperPermissionPipe,
  ],
  exports: [
    TopMenuComponent,
    RouterModule,
    AddStopComponent,
    JobComponent,
    AnSelectComponent,
    LoaderComponent,
    MapComponent,
    AddressPipe,
    DateDiffPipe,
    AddEventComponent,
    NoJobsComponent,
    JobShipperComponent,
    SelectTypeaheadComponent,
    AddNoteComponent,
    AddToMarketplaceComponent,
    CreateJobComponent,
    ProfilePhotoComponent,
    JobDocumentsComponent,
    ConfirmationPopupComponent,
    OffersComponent,
    SharedTemplatesComponent,
    ShippingLocationsComponent,
    ClientsTabComponent,
    CargoTabComponent,
    AddNewComponent,
    ToastersComponent,
    DragAndDropDirective,
    PhoneComponent,
    DotsComponent,
    AdditionalInfoComponent,
    BackToAdminComponent,
    DirectContractJobComponent,
    VerificationStatusComponent,
    DebounceDirective,
    DropdownComponent,
    UsersEditingComponent,
    JobShipperListViewComponent,
    SubconAddToMarketplaceComponent,
    LogoComponent,
    NoNegativeNumberValuePipe,
    CompanyDocumentsComponent,
    EcologiPopupComponent,
    PlaceOfferComponent,
    DateAgoPipe,
    ShareLoadComponent,
    SharedLinkComponent,
    DateWithTzPipe,
    MultiSelectDropdownComponent,
    PaginationScrollWithButtonComponent,
    HaulierDemoOverlayComponent,
    PieChartComponent,
    TimelineChartComponent,
    BarChartComponent,
    TypeaheadMultiselectComponent,
    HaulierNotActiveComponent,
    ChangePasswordComponent,
    PreventNegativeAndDecimalNumbersDirective,
    TenantStatusToggleComponent,
    TruckTypePipe,
    TrailerTypePipe,
    SpecialEquipmentPipe,
    EngineFuelTypePipe,
    NotesComponent,
    AssignDriverComponent,
    InfoBubbleComponent,
    ChatComponent,
    HaulierRatingComponent,
    TypeaheadComponent,
    ContractJobsListComponent,
    ContractJobContextMenuComponent,
    ContractMasterContextMenuComponent,
    ExtraChargeNoteComponent,
    UploadFileComponent,
    PublishLoadComponent,
    BookLoadComponent,
    ShareLoadsComponent,
    AddInnerLocationPopupComponent,
    ShipFromSectionComponent,
    WorkingHoursSectionComponent,
    GatesSectionComponent,
    SkuRejectionReasonsPipe,
    SkuOveragesReasonsPipe,
    ProfileMenuComponent,
    NotificationsComponent,
    AddEditSkuListComponent,
    CreateLoadForShipperOrClientPopupComponent,
    RemoveZeroValueOnInputFocus,
    FormatDistanceUnitPipe,
    BucksPerDistancePipe,
    MonthPickerComponent,
    WeekPickerComponent,
    ToggleSwitchComponent,
    DayPickerWithWeekdayComponent,
    ClientSearchComponent,
    ShipperSearchComponent,
    LocationSearchComponent,
    AddVehicleToYardComponent,
    VehicleOnYardStatusPipe,
    LoadingStartedPopupComponent,
    HaulierSearchComponent,
    PlatformNameReplacePipe,
    ActivateJobComponent,
    ContractJobsMasterListComponent,
    ContractJobMasterComponent,
    FuelTypePipePipe,
    StopActualTimesPopupComponent,
    ExtraChargeReasonPipePipe,
    ContractJobFiltersComponent,
    AddNewOrderComponent,
    StopComponent,
    StopDocumentsUploadComponent,
    FeatureFlagDirective,
    ClickOutsideDirective,
    BidHistoryComponent,
  ],
  providers: [
    AddressPipe,
    DateDiffPipe,
    DateAgoPipe,
    NoNegativeNumberValuePipe,
    FormatDistanceUnitPipe,
    BucksPerDistancePipe,
    VehicleOnYardStatusPipe,
    PlatformNameReplacePipe,
  ],
})
export class ComponentModule { }
